<template>
    <v-dialog v-model="shows" width="500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="primary">재가입 유예기간 설정</v-btn>
        </template>
        <v-card>
            <v-card-title>재가입 유예기간 설정</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-text-field v-model="form.value" label="기간" dense outlined hideDetails />
                    </v-col>
                    <v-col>
                        <v-select v-model="form.unit" label="단위" :items="unitItems" dense outlined hideDetails />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer />
                <v-btn @click="() => (shows = false)">취소</v-btn>
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";

function initForm(form = {}) {
    return {
        ...form,
        unit: form?.unit || "일",
        value: form?.value || 0,
    };
}

export default {
    data: () => ({
        shows: false,
        form: initForm(),
        unitItems: [
            { text: "일", value: "일" },
            { text: "개월", value: "개월" },
            { text: "년", value: "년" },
        ],
    }),
    mounted() {
        this.search();
    },
    methods: {
        async search() {
            try {
                let { setting } = await api.console.common.setting.get({});
                this.form = initForm(setting?.withdrawalOption);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async save() {
            try {
                await api.console.common.setting.put({ withdrawalOption: this.form });
                alert("저장되었습니다");
                this.shows = false;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    watch: {
        shows() {
            if (this.shows) this.search();
        },
    },
};
</script>

<style>
</style>